// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as _ from 'lodash';
// COMPONENTS
import { Spinner, Modal, Button, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { NavLink, Link } from 'react-router-dom';
import Select from 'react-select'
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-maskedinput';
import InputMask from "react-input-mask";
// CUSTOM COMPONENTS
import * as confirmModal from "../../../../redux/confirmModalRedux";
import * as alert from '../../../../redux/alertSnackBarRedux';
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as helper from '../../../../helpers/helper';
import * as jobService from "../../../../services/service/jobService";
import JobGeneralInfoValidator from "../../../../helpers/validators/JobGeneralInfoValidator";

const JobGeneralInfoPage = (props) => {
    const { showAlert, auth } = props;
    const [loading, setLoading] = useState(false);
    const [isAuthorizedToEdit, setIsAuthorizedToEdit] = useState(([auth.isAdmin, auth.isProjectManager, auth.isTechnician].includes(true)));
    const [job, setJob] = useState({
        proposal: {
            projectName: '',
            description: '',
            projectLocation: '',
            estimatedTotalCost: 0,
            budgetPercentage: 0,
            proposalProjectLocations: []
        },
        id: 0,
        proposalId: 0,
        siteContact: '',
        contactEmail: '',
        contactPhone: '',
        contractor: '',
        contractorPhoneNumber: '',
        contractorAddress: '',
        startDate: '',
        estimatedCompletionDate: '',
        estimatedNumberOfProjectManagers: '',
        estimatedNumberOfTechnicians: '',
        estimatedNumberOfWorkers: '',
        jobScope: '',
        sampleRequirements: '',
        wastePermit: '',
        wastehauler: '',
        landFill: '',
        jobNotes: '',
        duration: '',
        adminAllocationPercent: null
    })
    const { jobId } = useParams();

    useEffect(() => {
        fetchJob(jobId);
    }, [])

    const fetchJob = (jobId) => {
        setLoading(true);
        jobService.getJobById(jobId).then(res => {
            setJob(res);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => setLoading(false))
    }

    const saveJobHandler = (values, setSubmitting) => {
        jobService.saveJob(values).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            setSubmitting(false);
            setLoading(false);
        })
    }

    const formik = useFormik({
        initialValues: job,
        enableReinitialize: true,
        validationSchema: JobGeneralInfoValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            // let valuesToSend = _.pick(values, ['siteContact',  'contactEmail', 'contactEmail', 'startDate', 
            // 'estimatedCompletionDate', 'duration', 'jobScope', 'sampleRequirements', 'wastePermit', 'wastehauler', 'landfill', 'jobNotes']);
            saveJobHandler(values, setSubmitting);
        },
    });

    return (
        <div className="card card-custom" >
            {loading && <ModalProgressBar />}
            <form className="card card-custom" onSubmit={formik.handleSubmit}>
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            {isAuthorizedToEdit ? 'Edit Job' : 'View Job'}
                        </h3>
                        {
                            isAuthorizedToEdit &&
                            <span className="text-muted font-weight-bold fz-xs mt-1">
                                Please fill out the form below. Fields marked as * are editable.
                            </span>
                        }

                    </div>
                    {
                        isAuthorizedToEdit
                        &&
                        <div className="card-toolbar">
                            <button
                                type="submit"
                                className="btn btn-success mr-2"
                                disabled={
                                    formik.isSubmitting || (formik.touched && !formik.isValid)
                                }
                            >
                                Save Changes
                                {formik.isSubmitting}
                            </button>
                            <Link
                                to="/services/jobs"
                                className="btn btn-secondary"
                            >
                                Cancel
                            </Link>
                        </div>
                    }
                </div>
                <div className="form">
                    <div className="card-body">
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Project Name
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    readOnly
                                    value={job.proposal.projectName}
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="projectName"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Description
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="6"
                                    placeholder="Start typing..."
                                    readOnly
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="description"
                                    value={job.proposal.description}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Site Addresses
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                {/* <input
                                        type="text"
                                        readOnly
                                        value={job.proposal.proposalProjectLocations.map(x => x.projectLocation).join('; ')}
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="projectLocation"
                                    /> */}

                                <Form.Control as="textarea" rows="5"
                                    placeholder="No Job Locations"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="proposalProjectLocations"
                                    value={job.proposal.proposalProjectLocations.map(x => x.projectLocation).join('; ')}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Site Contact*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Enter Site Contact"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "siteContact")}`}
                                    name="siteContact"
                                    {...formik.getFieldProps("siteContact")}
                                />
                                {formik.touched.siteContact && formik.errors.siteContact ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.siteContact}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Email*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Enter contact Email"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "contactEmail")}`}
                                    name="contactEmail"
                                    {...formik.getFieldProps("contactEmail")}
                                />
                                {formik.touched.contactEmail && formik.errors.contactEmail ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.contactEmail}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Phone*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <InputMask
                                    mask="(999) 999-9999"
                                    type="text"
                                    placeholder="Enter Contact Phone"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "contactPhone")}`}
                                    name="contactPhone"
                                    {...formik.getFieldProps("contactPhone")}
                                />
                                {formik.touched.contactPhone && formik.errors.contactPhone ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.contactPhone}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contractor*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Enter Contractor"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "contractor")}`}
                                    name="contractor"
                                    {...formik.getFieldProps("contractor")}
                                />
                                {formik.touched.contractor && formik.errors.contractor ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.contractor}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contractor Phone*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <InputMask
                                    mask="(999) 999-9999"
                                    type="text"
                                    placeholder="Enter Contractor Phone"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "contractorPhoneNumber")}`}
                                    name="contractorPhoneNumber"
                                    {...formik.getFieldProps("contractorPhoneNumber")}
                                />
                                {formik.touched.contractorPhoneNumber && formik.errors.contractorPhoneNumber ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.contractorPhoneNumber}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contractor Address*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Enter Contractor Address"
                                    className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "contractorAddress")}`}
                                    name="contractorAddress"
                                    {...formik.getFieldProps("contractorAddress")}
                                />
                                {formik.touched.contractorAddress && formik.errors.contractorAddress ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.contractorAddress}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Start Date*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <DatePicker
                                    value={formik.getFieldProps("startDate").value ? helper.formatToUSDate(formik.getFieldProps("startDate").value) : null}
                                    dateFormat="MM/dd/yyyy"
                                    minDate={new Date()}
                                    selected={formik.getFieldProps("startDate").value ? new Date(formik.getFieldProps("startDate").value) : null}
                                    customInput={
                                        <MaskedInput
                                            className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "startDate")}`}
                                            mask="11/11/1111"
                                            placeholder="MM/DD/YYYY"
                                        />
                                    }
                                    onChange={(date) => {
                                        let selectedDate = helper.formatToUSDate(date);
                                        formik.setFieldValue("startDate", selectedDate);
                                        helper.calculateWorkingDays(selectedDate, formik.getFieldProps("estimatedCompletionDate").value).then(res => {
                                            formik.setFieldValue("projectDuration", res + ' days');
                                        }).catch(ex => console.log(ex));
                                    }}
                                    onBlur={(e) => {
                                        if (e.target.value.includes('_') || e.target.value === "") {
                                            formik.setFieldValue("startDate", '')
                                        }

                                        formik.setFieldTouched('startDate');
                                    }}
                                />
                                {formik.touched.startDate && formik.errors.startDate ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.startDate}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Estimated Completion Date*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <DatePicker
                                    value={formik.getFieldProps("estimatedCompletionDate").value ? helper.formatToUSDate(formik.getFieldProps("estimatedCompletionDate").value) : null}
                                    dateFormat="MM/dd/yyyy"
                                    minDate={new Date(formik.getFieldProps("startDate").value)}
                                    selected={formik.getFieldProps("estimatedCompletionDate").value ? new Date(formik.getFieldProps("estimatedCompletionDate").value) : null}
                                    customInput={
                                        <MaskedInput
                                            className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "estimatedCompletionDate")}`}
                                            mask="11/11/1111"
                                            placeholder="MM/DD/YYYY"
                                        />
                                    }
                                    onChange={(date) => {
                                        let selectedDate = helper.formatToUSDate(date)
                                        formik.setFieldValue("estimatedCompletionDate", selectedDate);
                                        helper.calculateWorkingDays(formik.getFieldProps("startDate").value, selectedDate).then(res => {
                                            formik.setFieldValue("duration", res + ' days');
                                        }).catch(ex => console.log(ex));
                                    }}
                                    onBlur={(e) => {
                                        if (e.target.value.includes('_') || e.target.value === "") {
                                            formik.setFieldValue("estimatedCompletionDate", '')
                                        }

                                        formik.setFieldTouched('estimatedCompletionDate');
                                    }}
                                />
                                {formik.touched.estimatedCompletionDate && formik.errors.estimatedCompletionDate ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.estimatedCompletionDate}
                                    </div>
                                ) : null}
                            </div>

                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Project Duration
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Select Start Date and Estmated Completion Date"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="duration"
                                    {...formik.getFieldProps("duration")}
                                />
                                <span className="form-text text-muted">Project Duration will automatically be calcaulated based on start and estimated completed date entered</span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Project Budget
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    readOnly
                                    value={"$" + (job.proposal.estimatedTotalCost - (job.proposal.budgetPercentage * job.proposal.estimatedTotalCost) / 100).toFixed(2)}
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="projectNumber"
                                />
                                <span className="form-text text-muted">Project Budget is calculated from Project Estimator in the proposal</span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Estimated No. Of Project Managers
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    placeholder="Estimated Number Of Project Managers"
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="estimatedNumberOfProjectManagers"
                                    {...formik.getFieldProps("estimatedNumberOfProjectManagers")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Estimated No. Of Technicians
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    placeholder="Estimated Number Of Technicians"
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="estimatedNumberOfTechnicians"
                                    {...formik.getFieldProps("estimatedNumberOfTechnicians")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Estimated No. Of Workers
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    placeholder="Estimated Number Of Workers"
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="estimatedNumberOfWorkers"
                                    {...formik.getFieldProps("estimatedNumberOfWorkers")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Job Scope
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="8"
                                    placeholder="Start typing..."
                                    disabled
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="jobScope"
                                    {...formik.getFieldProps("jobScope")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Sample Requirements/Strategy*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="3"
                                    placeholder="Start typing..."
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="sampleRequirements"
                                    {...formik.getFieldProps("sampleRequirements")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Waste Permit/ADVF*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    placeholder="Enter Waster Permit/ADVF"
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="wastePermit"
                                    {...formik.getFieldProps("wastePermit")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Waste Hauler*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="3"
                                    placeholder="Start typing..."
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="wastehauler"
                                    {...formik.getFieldProps("wastehauler")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Disposal Site*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    placeholder="Enter Landfill"
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="landfill"
                                    {...formik.getFieldProps("landFill")}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Job Notes*
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="6"
                                    placeholder="Start typing..."
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="jobNotes"
                                    {...formik.getFieldProps("jobNotes")}
                                />
                            </div>
                        </div>
                        {(auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip')) && (
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Admin Allocation %
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="number"
                                        step="0.01"
                                        placeholder="Leave empty to use year default (e.g., 0.18 = 18%)"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="adminAllocationPercent"
                                        value={formik.values.adminAllocationPercent || ''}
                                        onChange={(e) => {
                                            const val = e.target.value === '' ? null : parseFloat(e.target.value);
                                            formik.setFieldValue('adminAllocationPercent', val);
                                        }}
                                    />
                                    <small className="form-text text-muted">
                                        Custom admin cost allocation percentage for this job. Leave empty to use the year's default setting.
                                    </small>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(JobGeneralInfoPage);